import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { TypedCanActivateFn } from '@/common/models';
import { AppInitializerService } from '@/common/services';
import { AuthTranslationPreloaderService } from '@/pages/auth/services/auth-translation-preloader.service';
import { AuthService } from '@/pages/auth/services/auth.service';

export const AuthGuard: TypedCanActivateFn<Observable<boolean>> = (): Observable<boolean> => {
  const authService = inject(AuthService);
  const appInitializerService = inject(AppInitializerService);
  const authTranslationPreloader = inject(AuthTranslationPreloaderService);

  // Esperar a que las traducciones básicas estén cargadas antes de validar autenticación
  return appInitializerService.translationsReady$.pipe(
    filter(ready => ready), // Solo proceder cuando las traducciones estén listas
    take(1), // Completar después de la primera emisión verdadera
    switchMap(() => authTranslationPreloader.preloadAuthTranslations().pipe(// ⚡ SIEMPRE precargar traducciones de auth (por si acaso se necesita mostrar login)
      map(() => {
        const isLogged = authService.isLogged();

        if (!isLogged) {
          authService.logout();
          return false;
        }

        return true;
      }),
    )),
  );
};

